import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import React, { useCallback, useEffect, useMemo, useState } from "react";

import ContentLayout from "app/layouts/ContentLayout";

import PageError from "app/components/CommonPage/PageError";
import PageLoading from "app/components/CommonPage/PageLoading";
import PageNoData from "app/components/CommonPage/PageNoData";
import OrderSumaryUpdateTable from "app/components/Table/Order/OrderSumaryUpdateTable";
import TestMaterialInfoTableForm from "app/components/Table/Order/TestMaterialInfoTableForm";
import Button from "app/components/UI/Button";
import SelectTestScheduleAndCaseId from "app/components/UI/Form/Select/SelectTestScheduleAndCaseId";
import routePaths from "app/route/routePaths";
import { commonServices, customerServices } from "app/services/api";
import moment from "moment";
import { toast } from "react-toastify";
import PageLoadingBackdrop from "../../../components/CommonPage/PageLoadingBackdrop";
import CustomerTableInfo from "../../../components/Table/Customer/CustomerTableInfo";
import { caseStatus, fileNameType } from "../../../constants";
import messages from "../../../services/api/messages";
import orderServices from "../../../services/api/orderServices";
import { getAddressFromComponent, getNameKanji } from "../../../utils";
import AddressCell from "../CustomerCustomTableCell/AddressCell";
import DepartmentCell from "../CustomerCustomTableCell/DepartmentCell";
import { validateTestMaterialInfosConfig } from "../validate";
import PhoneCell from "../CustomerCustomTableCell/PhoneCell";
import { getMessageFromCaseStatus } from "app/utils/getMessageFromCaseStatus";

const customerConfig = [
  {
    title: "企業・団体名",
    shouldEdit: true,
    showInput: false,
    dataKey: "customerName",
  },
  {
    title: "所在地",
    shouldEdit: true,
    showInput: false,
    dataKey: ["customerPostalCode", "customerAddress"],
    CustomTableCell: AddressCell,
  },
  {
    title: "TEL",
    dataKey: "phone1",
    shouldEdit: true,
    showInput: false,
    CustomTableCell: PhoneCell,
  },
  {
    title: "担当者",
    shouldEdit: true,
    showInput: false,
    dataKey: ["department", "picNameKanji"],
    CustomTableCell: DepartmentCell,
  },
];

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function CreateTestContentInfoForm(props) {
  const {
    testContentInfoItem,
    setTestContentInfoItem,
    requestFormInfo,
    setRequestFormInfo,
    customerTable,
    onChangeCustomer,
    handleClickEditCus,
  } = props;

  const [showTab, setShowTab] = useState(0);

  const handleChangeTab = (event, newValue) => {
    setShowTab(newValue);
  };

  const handleChangeTestMaterial = (index, newValue) => {
    const newTestMaterialInfos = [...testContentInfoItem?.testMaterialInfos];
    newTestMaterialInfos[index] = newValue;
    setTestContentInfoItem({
      ...testContentInfoItem,
      testMaterialInfos: newTestMaterialInfos,
    });
  };

  return (
    <div className="w-full h-auto">
      <div className="w-full h-auto mb-10">
        <CustomerTableInfo
          id="lab"
          key="lab"
          tableConfig={[
            {
              title: "項目",
              width: "25%",
              textAlign: "left",
            },
            {
              title: "詳細",
              width: "75%",
              textAlign: "left",
            },
          ]}
          tableData={customerTable}
          onClickEdit={handleClickEditCus}
          handleChange={onChangeCustomer}
        />
      </div>

      <div className="w-full h-auto mb-10">
        <OrderSumaryUpdateTable
          testContentInfoItem={testContentInfoItem}
          isReadonly={false}
          requestFormInfo={requestFormInfo}
          setRequestFormInfo={setRequestFormInfo}
        />
      </div>

      <div className="w-full">
        {testContentInfoItem.testMaterialInfos.length > 1 && (
          <div className="border-b w-full overflow-x-auto">
            <Tabs
              value={showTab}
              onChange={handleChangeTab}
              aria-label="basic tabs example"
              className="mb-3"
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                "& .MuiTabScrollButton-root.Mui-disabled": {
                  opacity: 0.3,
                },
              }}
            >
              {testContentInfoItem.testMaterialInfos.map((item, index) => (
                <Tab
                  key={`tab-${index}`}
                  label={`${index + 1}`}
                  className="!min-w-[45px]"
                  {...a11yProps(index)}
                />
              ))}
            </Tabs>
          </div>
        )}

        {testContentInfoItem.testMaterialInfos.map((item, index) => (
          <CustomTabPanel key={index} value={showTab} index={index}>
            <TestMaterialInfoTableForm
              testMaterialNo={index + 1}
              testMaterialInfo={item}
              setTestMaterialInfo={(newValue) =>
                handleChangeTestMaterial(index, newValue)
              }
            />
          </CustomTabPanel>
        ))}
      </div>
    </div>
  );
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div className="w-full h-full">{children}</div>}
    </div>
  );
}

function CreateOrderForm({
  initOrderInfo,
  customerInfo,
  testScheduleId,
  caseId,
  handleSearch,
}) {
  const [requestFormInfo, setRequestFormInfo] = useState(initOrderInfo);
  const [showTab, setShowTab] = useState(0);
  const [isCreating, setIsCreating] = useState(false);
  const [customerTable, setCustomerTable] = useState(
    customerConfig.map((i) => {
      const detail = [];
      if (Array.isArray(i.dataKey)) {
        i.dataKey.forEach((d) => {
          detail[d] = customerInfo[d];
        });
      }
      return {
        ...i,
        detail: Array.isArray(i.dataKey) ? detail : customerInfo[i.dataKey],
      };
    })
  );

  const handleChangeTestContentInfo = (index, newValue) => {
    setRequestFormInfo((oldState) => {
      const newTestContentInfos = [...oldState.testContentInfos];
      newTestContentInfos[index] = newValue;
      return {
        ...oldState,
        testContentInfos: newTestContentInfos,
      };
    });
  };

  const handleChangeTab = (event, newValue) => {
    setShowTab(newValue);
  };

  const validateForm = (data) => {
    let textErrors = [];

    validateTestMaterialInfosConfig.forEach((valid) => {
      if (!valid.value && !valid.required_if && !requestFormInfo[valid.name]) {
        textErrors.push(valid.text);
      }
      if (
        valid.value &&
        requestFormInfo[valid.name] &&
        requestFormInfo[valid.name] === valid.value
      ) {
        if (!textErrors.includes(valid.text)) {
          textErrors.push(valid.text);
        }
      }
      requestFormInfo.testContentInfos?.forEach((testContentInfo) => {
        testContentInfo.testMaterialInfos.forEach((testMaterialInfo) => {
          if (
            valid.value &&
            testMaterialInfo[valid.name] &&
            testMaterialInfo[valid.name] === valid.value
          ) {
            if (!textErrors.includes(valid.text)) {
              textErrors.push(valid.text);
            }
          }

          if (
            valid.required_if &&
            testMaterialInfo[valid.required_if] &&
            testMaterialInfo[valid.required_if] === valid.required_value
          ) {
            if (!testMaterialInfo[valid.name]) {
              if (!textErrors.includes(valid.text)) {
                textErrors.push(valid.text);
              }
            }
          }
        });
      });
    });

    return textErrors;
  };

  const handleConfirmCreate = () => {
    if (isCreating) return;

    const textErrors = validateForm(getData());

    if (textErrors.length > 0) {
      textErrors.forEach((text) => {
        toast.error(text + "を記入してください。");
      });

      return;
    }

    const data = {
      ...requestFormInfo,
      testSchedule: testScheduleId,
      generatedPdf: undefined,
      caseId,
    };

    setIsCreating(true);
    orderServices
      .genFileRequestForm(data)
      .then((res) => {
        const generatedWord = res?.data?.generatedWord;
        setRequestFormInfo((oldState) => ({
          ...oldState,
          generatedPdf: generatedWord._id,
        }));
        setIsCreating(false);

        customerServices
          .getDetail()
          .then((res) => {
            const customerName = res?.data?.companyNameKanji || "";

            const fileType = fileNameType["requestForm"];
            const timeStamp = moment().format("YYYYMMDDHHmmss");

            setTimeout(() => {
              commonServices
                .downloadWithFileId(
                  generatedWord._id,
                  "docx",
                  `${fileType}_${customerName}_${timeStamp}`
                )
                .catch(() => {
                  toast.error(messages.downloadFail);
                });
            }, 300);
            setTimeout(() => {
              commonServices
                .downloadPDFWithFileId(
                  generatedWord._id,
                  `${fileType}_${customerName}_${timeStamp}`
                )
                .catch(() => {
                  toast.error(messages.downloadFail);
                });
            }, 500);
          })
          .catch(() => toast.error(messages.callApiFail));
      })
      .catch((error) => {
        console.log("error: ", error);
        toast.error(messages.callApiFail);
        setIsCreating(false);
      });
  };

  const getData = () => {
    customerTable.forEach((i) => {
      if (Array.isArray(i.dataKey)) {
        i.dataKey.forEach((key) => {
          requestFormInfo[key] = i.detail[key] ?? "";
        });
      } else {
        requestFormInfo[i.dataKey] = i.detail;
      }
    });

    const data = {
      ...requestFormInfo,
      testSchedule: testScheduleId,
      caseId,
    };

    return data;
  };

  const handleSubmitCreate = () => {
    if (isCreating || !requestFormInfo?.generatedPdf) return;

    const data = getData();

    const textErrors = validateForm(data);

    if (textErrors.length > 0) {
      textErrors.forEach((text) => {
        toast.error(text + "を入力してください。");
      });

      return;
    }

    setIsCreating(true);
    orderServices
      .createRequestForm(data)
      .then(() => {
        toast.success(messages.create(true));
        setIsCreating(false);
        setTimeout(() => {
          handleSearch();
        }, 1000);
      })
      .catch((error) => {
        console.log("error: ", error);
        toast.error(messages.create(false));
        setIsCreating(false);
      });
  };

  const handleSaveDraft = () => {
    if (isCreating) return;

    const data = getData();

    setIsCreating(true);
    orderServices
      .createDraftRequestForm(data)
      .then(() => {
        toast.success(messages.draft(true));
        setIsCreating(false);
        setTimeout(() => {
          handleSearch();
        }, 1000);
      })
      .catch((error) => {
        console.log("error: ", error);
        toast.error(messages.draft(false));
        setIsCreating(false);
      });
  };

  const handleResetForm = () => {
    setRequestFormInfo(initOrderInfo);
    toast.success("フォームのリセットが成功しました。");
  };

  const handleClickEditCus = (dataKey) => {
    const newCus = customerTable.map((c) => ({
      ...c,
      showInput: c.dataKey === dataKey ? !c.showInput : c.showInput,
    }));
    setCustomerTable(newCus);
  };

  const onChangeCustomer = (name, value) => {
    const newCus = customerTable.map((c) => {
      const detail = c.detail;

      if (Array.isArray(c.detail)) {
        c.detail[name] = value;
      }

      return {
        ...c,
        detail: Array.isArray(c.dataKey)
          ? detail
          : c.dataKey === name
          ? value
          : c.detail,
      };
    });
    setCustomerTable(newCus);
  };

  return (
    <>
      <div className="w-full h-auto">
        <div className="w-full h-auto flex items-center justify-start mb-4">
          <h3 className="text-custom-size">試験内容</h3>
        </div>

        <div className="w-full">
          <div className="w-full overflow-x-auto">
            <Tabs
              value={showTab}
              onChange={handleChangeTab}
              aria-label="basic tabs example"
              className="mb-3"
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                "& .MuiTabScrollButton-root.Mui-disabled": {
                  opacity: 0.3,
                },
              }}
            >
              {requestFormInfo?.testContentInfos?.map(
                (testContentInfoItem, index) => {
                  return testContentInfoItem?.testMaterialInfos?.length > 0 ? (
                    <Tab
                      key={index}
                      label={
                        testContentInfoItem?.testItemName || `Tab ${index + 1}`
                      }
                      {...a11yProps(index)}
                    />
                  ) : null;
                }
              )}
            </Tabs>
          </div>

          {requestFormInfo?.testContentInfos?.map(
            (testContentInfoItem, index) => {
              return testContentInfoItem?.testMaterialInfos?.length > 0 ? (
                <CustomTabPanel key={index} value={showTab} index={index}>
                  <CreateTestContentInfoForm
                    testContentInfoItem={testContentInfoItem}
                    setTestContentInfoItem={(newValue) =>
                      handleChangeTestContentInfo(index, newValue)
                    }
                    requestFormInfo={requestFormInfo}
                    setRequestFormInfo={setRequestFormInfo}
                    customerTable={customerTable}
                    handleClickEditCus={handleClickEditCus}
                    onChangeCustomer={onChangeCustomer}
                  />
                </CustomTabPanel>
              ) : null;
            }
          )}
        </div>

        <div className="w-full h-auto flex items-center justify-end gap-4 -mt-6">
          <Button type="secondary" onClick={handleSaveDraft}>
            下書きを保存
          </Button>
          <Button type="danger" onClick={handleResetForm}>
            クリア
          </Button>
          <Button onClick={handleConfirmCreate}>確認する</Button>
          <Button
            disabled={!requestFormInfo?.generatedPdf}
            type={!requestFormInfo?.generatedPdf ? "disabled" : "primary"}
            onClick={handleSubmitCreate}
          >
            提出する
          </Button>
        </div>
      </div>

      <PageLoadingBackdrop open={isCreating} />
    </>
  );
}

function CreateOrderContent({
  testScheduleId,
  quotationInfoId,
  caseId,
  searchResult,
  handleSearch,
}) {
  const [loadInit, setLoadInit] = useState({
    isLoading: false,
    data: searchResult
      ? {
          initRequestForm: {
            planPresentation: searchResult?.planPresentation,
            returnTestMaterial: searchResult?.returnTestMaterial,
            testContentInfos: searchResult?.testContentInfos,
            reportCreationMethod: searchResult?.reportCreationMethod,
            billingAddress: searchResult?.billingAddress,
          },
          customerInfo: {
            customerAddress: searchResult?.customerAddress,
            customerName: searchResult?.customerName,
            phone1: searchResult?.phone1,
            customerPostalCode: searchResult?.customerPostalCode,
            department: searchResult?.pic?.department || searchResult?.department,
            picNameKanji: searchResult?.pic ? getNameKanji(searchResult?.pic) : searchResult?.picNameKanji,
          },
        }
      : null,
    error: null,
  });

  const loadInitRequestForm = useCallback(() => {
    setLoadInit({
      isLoading: true,
      data: null,
      error: null,
    });

    Promise.all([
      orderServices.getInitRequestFormByQuotationInfoId(quotationInfoId),
      customerServices.getDetail(),
    ])
      .then(([resInit, cusRes]) => {
        const cusCombined = {
          customerAddress: getAddressFromComponent(cusRes.data, false),
          customerName: cusRes.data.companyNameKanji,
          phone1: cusRes.data.phone1,
          customerPostalCode: cusRes.data.postalCode,
          department: cusRes.data?.pic?.department,
          picNameKanji: getNameKanji(cusRes.data?.pic)?.trim() || '',
        };

        setLoadInit({
          isLoading: false,
          data: {
            initRequestForm: resInit.data,
            customerInfo: cusCombined,
          },
          error: null,
        });
      })
      .catch((err) => {
        console.log("erorr: ", err);
        toast.error(messages.callApiFail);
        setLoadInit({
          isLoading: false,
          data: null,
          error: err,
        });
      });
  }, [quotationInfoId]);

  useEffect(() => {
    if (!searchResult) {
      loadInitRequestForm();
    }
  }, [loadInitRequestForm, searchResult]);

  if (loadInit.isLoading) return <PageLoading />;
  if (loadInit.error) return <PageError />;

  if (loadInit.data) {
    if (loadInit.data.initRequestForm)
      return (
        <CreateOrderForm
          initOrderInfo={loadInit.data.initRequestForm}
          customerInfo={loadInit.data.customerInfo}
          testScheduleId={testScheduleId}
          caseId={caseId}
          handleSearch={handleSearch}
        />
      );

    return <PageNoData />;
  }

  return null;
}

function CreateOrder() {
  const [selectedTestSchedule, setSelectedTestSchedule] = useState(null);
  const [selectedCaseInfo, setSelectedCaseInfo] = useState(null);

  const [searchState, setSearchState] = useState({
    isLoading: false,
    testScheduleId: "",
    searchResult: null,
    error: null,
  });

  const reset = () => {
    setSelectedCaseInfo(null);
    setSearchState({
      isLoading: false,
      testScheduleId: "",
      searchResult: null,
      error: null,
    });
  };

  const handleSearch = () => {
    if (
      searchState?.isLoading ||
      !selectedTestSchedule ||
      !selectedTestSchedule?.id ||
      !selectedCaseInfo
    )
      return;

    setSearchState({
      isLoading: true,
      testScheduleId: selectedTestSchedule?.id,
      searchResult: null,
      error: null,
    });

    orderServices
      .getByCaseId(selectedCaseInfo?._id)
      .then((res) => {
        setSearchState((oldState) => ({
          ...oldState,
          isLoading: false,
          searchResult: res.data,
          error: null,
        }));
      })
      .catch((error) => {
        toast.error(messages.callApiFail);
        setSearchState((oldState) => ({
          ...oldState,
          isLoading: false,
          searchResult: null,
          error: error,
        }));
      });
  };

  const disableButtonSearch = useMemo(() => {
    return (
      !selectedCaseInfo ||
      selectedCaseInfo.caseStatus === caseStatus.completed ||
      selectedCaseInfo.caseStatus === caseStatus.lost
    );
  }, [selectedCaseInfo]);

  const renderCreateOrder = () => {
    const message = getMessageFromCaseStatus(selectedCaseInfo, false);
    if (message) {
      return (
        <div className="w-full h-auto">
          <p className="text-custom-size mb-3">{message}</p>
        </div>
      );
    }

    if (searchState.testScheduleId) {
      return searchContent({ handleSearch, searchState, selectedCaseInfo });
    }

    return null;
  };

  return (
    <ContentLayout
      sideMenuLinkOptions={[
        { linkTo: routePaths.order, linkTitle: "発注書の検索" },
        {
          linkTitle: "発注書の修正",
          linkTo: routePaths.orderUpdate(),
        },
        {
          linkTo: routePaths.orderCreate,
          linkTitle: "発注書の作成",
        },
        { linkTo: routePaths.topMenu, linkTitle: "トップへ戻る" },
      ]}
    >
      <div className="w-full h-auto">
        <div className="w-full h-auto mb-7 text-custom-size">
          <p>発注書（依頼書）の作成</p>
        </div>

        <div className="w-full h-auto flex items-end mb-12 flex-wrap">
          <div className="w-full mb-3 md:mb-0 md:w-auto flex-grow">
            <SelectTestScheduleAndCaseId
              schedule={selectedTestSchedule}
              setSchedule={(value) => {
                reset();
                setSelectedTestSchedule(value);
              }}
              caseInfo={selectedCaseInfo}
              setCaseInfo={(value) => {
                setSearchState({
                  isLoading: false,
                  testScheduleId: "",
                  searchResult: null,
                  error: null,
                });
                setSelectedCaseInfo(value);
              }}
              labelWidth={180}
            />
          </div>
          <div className="w-full md:w-auto shrink-0 pl-12 flex justify-end">
            <Button
              onClick={handleSearch}
              disabled={disableButtonSearch}
              type={disableButtonSearch ? "disabled" : "primary"}
            >
              呼び出す
            </Button>
          </div>
        </div>

        {renderCreateOrder()}
      </div>
    </ContentLayout>
  );
}

const searchContent = ({ handleSearch, searchState, selectedCaseInfo }) => {
  if (searchState.isLoading) return <PageLoading />;
  if (searchState.error) return <PageError />;

  const status = searchState?.searchResult?.status;

  if (
    searchState.searchResult &&
    (status === "registered" || !status)
  ) {
    return (
      <div className="w-full h-full flex flex-col items-center justify-center py-12">
        <p className="text-xl font-semibold text-gray-600 mb-6 text-center">
          <p>試験スケジュールは既に作成しました。</p>
          <p>修正必要な場合は、修正ページへ移動してください。</p>
        </p>
      </div>
    );
  }

  return (
    <CreateOrderContent
      testScheduleId={searchState.testScheduleId}
      caseId={selectedCaseInfo._id}
      quotationInfoId={selectedCaseInfo.quotation}
      searchResult={searchState.searchResult}
      handleSearch={handleSearch}
    />
  );
};

export default CreateOrder;
